import React from "react";
import PropTypes from "prop-types";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import {connect} from "react-redux";
import i18next from "i18next";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";

class TrackOwnCompanyFindForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            height: window.innerHeight,
            exchangeAgreementSelectedIndex: 0,
            isRefreshed: false,
        };
    }

    async componentDidMount() {
        this.updateWindowHeight();
        window.addEventListener('resize', this.updateWindowHeight);
        await this.init();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.popupVisible && !this.props.popupVisible) {
            await this.props.dispatch(this.props.truckOwnCompanyFind.reset());
            await this.props.dispatch(this.props.truckOwnCompanyFindParams.reset());
            await this.props.dispatch(this.props.truckOwnCompanyExchangeAgreement.reset());
            this.setState({ isRefreshed: false });
        }
        else if(!prevProps.popupVisible && this.props.popupVisible)
            await this.init();
    }

    init = async() => {
        try {
            if(!this.props.truckOwnCompanyFind.isInitialized) {
                await this.props.dispatch(this.props.truckOwnCompanyFind.execute({}, {
                    withParams: true,
                    refresh: false,
                    newItem: true
                }));
            }
        }
        catch (e) {
            console.log(e);
        }
    };

    dateToString = (date) => {
        return date.toISOString().substr(0, 11) + "00:00:00";
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowHeight);
    }

    updateWindowHeight = () => {
        this.setState({ height: window.innerHeight });
    };

    isNewCompany = () => {
        return this.props.truckOwnCompanyFind.isInitialized
            && this.props.truckOwnCompanyFind.rowsCount() > 0
            && this.props.truckOwnCompanyFind.getField(0, "IsNew") === 1;
    }

    onSearchCompany = async (e) => {
        e.preventDefault();
        await this.props.dispatch(this.props.truckOwnCompanyExchangeAgreement.reset());
        await this.props.dispatch(this.props.truckOwnCompanyFind.applyParams(this.props.truckOwnCompanyFindParams))
        this.setState({isRefreshed: true});

        if(!this.isNewCompany())
            await this.props.dispatch(this.props.truckOwnCompanyExchangeAgreement.execute(this.props.truckOwnCompanyFind.getRow(0)));
    }

    onAddCompany = async (e) => {
        e.preventDefault();
        await this.props.dispatch(this.props.truckOwnCompanyAdd.execute(this.props.truckOwnCompanyFind.getRow(0), {newItem: true}));
        await this.onSearchCompany(e);
    }

    onSelectExchangeAgreement = (selectedIndex) => {
        this.setState({exchangeAgreementSelectedIndex: selectedIndex})
    }

    onSelectCompany = (e) => {
        e.preventDefault();

        let selectedKey = this.props.truckOwnCompanyExchangeAgreement.getRowKeyByIndex(this.state.exchangeAgreementSelectedIndex);

        this.props.onSelect(selectedKey);
    };

    renderCompanyFindParams = () => {
        if (!this.props.truckOwnCompanyFind.isInitialized) {
            return null;
        }

        return (
            <ComplexParam dataItem={this.props.truckOwnCompanyFindParams}
                          parentDataItem={this.props.truckOwnCompanyFind}
                          autoApplyParams={false}
                          renderParams={this.renderCompanyFindParamsRow}
            />
        )
    }

    renderCompanyFindParamsRow = (h) => {
        return (
            <>
                <div className="row">
                    <div className="col-md-1 field-title">
                        {h.lbl("INN")}
                    </div>
                    <div className="col-md-4">
                        {h.ed("INN")}
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-regular" onClick={this.onSearchCompany}>Найти</button>
                    </div>
                </div>
            </>
        );
    }

    renderFoundedCompanyData = (h) => {
        return (
            <>
                {h.fs.map(fi => {
                    if(fi.IsHidden)
                        return null;

                    return (
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fi.Name)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fi.Name)}
                            </div>
                        </div>
                    )
                })}
            </>
        );
    }

    renderFoundedCompany = () => {
        if (!this.props.truckOwnCompanyFind.isInitialized) {
            return null;
        }

        if (this.props.truckOwnCompanyFind.rowsCount() === 0) {
            if(!this.state.isRefreshed) {
                return null;
            }

            return (<div className="row">
                <div className="col-md-12">Компания не найдена</div>
            </div>)
        }

        return (
            <>
                <ComplexParam dataItem={this.props.truckOwnCompanyFind}
                              renderParams={this.renderFoundedCompanyData}
                              autoApplyParams={false}
                              readOnly={true}
                />
                {this.isNewCompany() &&
                <button className="btn btn-regular" onClick={this.onAddCompany}>Добавить компанию</button>}
            </>
        )
    }

    renderExchangeAgreement = () => {
        if(!this.props.truckOwnCompanyExchangeAgreement.isInitialized || this.props.truckOwnCompanyExchangeAgreement.inOperation)
            return null;

        if(this.props.truckOwnCompanyExchangeAgreement.rowsCount() === 0)
            return (
                <div className="row">
                    <div className="col-md-12">
                        Соглашения не найдены
                    </div>
                </div>
            )

        return (
            <>
                <div className="row">
                    <div className="col-md-3 field-title">
                        Соглашение об обмене
                    </div>
                    <div className="col-md-9">
                        <MnComboStandalone ownItem={this.props.truckOwnCompanyExchangeAgreement}
                                           onSelected={this.onSelectExchangeAgreement}
                                           valueFieldName={"EDMemberCode"}
                                           withSearch={false}
                                           allowReset={false}/>
                    </div>
                </div>
                <button className="btn btn-regular" onClick={this.onSelectCompany}>Выбрать компанию</button>
            </>
        )
    }

    render() {
        if (!this.props.truckOwnCompanyFind.isInitialized) {
            return null;
        }

        return (
            <PopupWrapper popupVisible={this.props.popupVisible}
                          title={this.props.title}
                          onClose={this.props.onClose}
                          renderButtons={() => {return null;}}>
                {this.renderCompanyFindParams()}
                {this.renderFoundedCompany()}
                {this.renderExchangeAgreement()}
            </PopupWrapper>
        );
    }
}

TrackOwnCompanyFindForm.propTypes = {
    dispatch: PropTypes.func,
    truckOwnCompanyFind: PropTypes.object.isRequired,
    truckOwnCompanyFindParams: PropTypes.object.isRequired,
    truckOwnCompanyAdd: PropTypes.object.isRequired,
    truckOwnCompanyExchangeAgreement: PropTypes.object.isRequired,
    title: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    popupVisible: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    return {
        truckOwnCompanyFind: state.transportState.truckOwnCompanyFind,
        truckOwnCompanyFindParams: state.transportState.truckOwnCompanyFindParams,
        truckOwnCompanyAdd: state.transportState.truckOwnCompanyAdd,
        truckOwnCompanyExchangeAgreement: state.transportState.truckOwnCompanyExchangeAgreement,
    };
};

export default connect(mapStateToProps)(TrackOwnCompanyFindForm);